(($) => {
  const highlight = ($eventText, $eventImage) => {
    $eventText.addClass('active');
    $eventImage.addClass('active');
  };

  const unhighlight = ($eventText, $eventImage) => {
    $eventText.removeClass('active');
    $eventImage.removeClass('active');
  };

  for (let i = 1; i <= 4; i++) {
    const $eventImage = $(`#event-image-${i}`);
    const $eventText = $(`#event-text-${i}`);

    $eventText.mouseover(() => {
      highlight($eventText, $eventImage);
    });

    $eventText.mouseout(() => {
      unhighlight($eventText, $eventImage);
    });

    $eventImage.mouseover(() => {
      highlight($eventText, $eventImage);
    });

    $eventImage.mouseout(() => {
      unhighlight($eventText, $eventImage);
    });
  }
  /* eslint-disable-next-line no-undef */
})(jQuery);
